import { Trans, useTranslation } from "react-i18next";
import { Button, Flex, Typography } from "antd";
import type { ServiceInstanceDTO } from "api";

import { ServiceListItem } from "./BusinessServicesListItem.styles";

const durationMin = 30;

export interface BusinessServicesListItemProps {
  service: ServiceInstanceDTO;
}

const BusinessServicesListItem: React.FC<BusinessServicesListItemProps> = ({
  service: { price, customName, description },
}) => {
  const { t } = useTranslation();

  return (
    <ServiceListItem
      actions={[
        <Flex vertical gap={4}>
          <Typography.Text strong>
            {price?.discountValue} {price?.currency}
          </Typography.Text>
          <Typography.Text type="secondary">{durationMin} min</Typography.Text>
        </Flex>,
        <Button color="primary" variant="solid" onClick={() => {}}>
          <Trans i18nKey="business.actions.book" />
        </Button>,
      ]}
    >
      <ServiceListItem.Meta
        title={customName}
        description={description ?? t("business.details.description.placeholder")}
      />
    </ServiceListItem>
  );
};

export default BusinessServicesListItem;
